import React from 'react';
import { FormattedMessage } from 'react-intl';
import defaultImage from 'src/static/images/sources/default-source.jpg';
import { FeedbackEnum, SourceData } from 'src/types';
import './SourceCard.sass';

interface SourceProps {
	isInternet?: boolean;
	source: SourceData;
	isSimple?: boolean;
	index?: number;
	isUnused?: boolean;
	isOutdated?: boolean;
	selectSourceURLFeedback?: (newSourceUrlFeedback: FeedbackEnum | undefined) => void;
	sourceURLFeedback?: FeedbackEnum | undefined;
}

const SourceCard = ({
	isInternet,
	source,
	isSimple = false,
	index,
	isUnused = false,
	isOutdated = false,
	selectSourceURLFeedback,
	sourceURLFeedback
}: SourceProps) => {
	const { url, image, title, description, site, icon } = source;
	if (!url) return;
	const years = window?._env_?.YEARS ?? 2;
	return (
		<>
			<a
				href={url}
				rel="noopener noreferrer"
				target="_blank"
				className={`source-card ${isUnused ? 'unused-card' : ''} ${
					isOutdated && !isUnused ? 'outdated-card' : ''
				} ${selectSourceURLFeedback ? 'with-buttons-card' : ''}`}
			>
				{!isSimple && (
					<div className="source-image">
						<img loading="lazy" src={image || defaultImage} alt={` ${site}`} />
					</div>
				)}
				<div className="source-info">
					<header>
						{icon && <img src={icon} alt={`${site} icon`} />}
						<h2>{site || (isInternet ? 'internet' : 'site')}</h2>
					</header>
					<p>
						<span dangerouslySetInnerHTML={{ __html: title || description || url }} />
					</p>
				</div>
				{isOutdated && !isUnused && (
					<span className="outdated-advice">
						<FormattedMessage id="outdated-advice" values={{ y: years }} />
					</span>
				)}
				{!isUnused && <span className="index">{index}</span>}
			</a>
			{selectSourceURLFeedback && (
				<div className="buttons source-card-buttons">
					<div className="left">
						<button
							onClick={() => selectSourceURLFeedback(sourceURLFeedback !== FeedbackEnum.LIKE ? FeedbackEnum.LIKE : undefined)}
							className={`icon icon-hand-up ${sourceURLFeedback === FeedbackEnum.LIKE ? 'active' : ''}`}
						/>
						<button
							onClick={() => selectSourceURLFeedback(sourceURLFeedback !== FeedbackEnum.DISLIKE ? FeedbackEnum.DISLIKE : undefined)}
							className={`icon icon-hand-down ${sourceURLFeedback === FeedbackEnum.DISLIKE ? 'active' : ''}`}
						/>
					</div>
				</div>
			)}
		</>
	);
};

export default React.memo(SourceCard);
